import { render, staticRenderFns } from "./loadingChart.vue?vue&type=template&id=94ed7a38&scoped=true"
import script from "./loadingChart.vue?vue&type=script&lang=js"
export * from "./loadingChart.vue?vue&type=script&lang=js"
import style0 from "./loadingChart.vue?vue&type=style&index=0&id=94ed7a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ed7a38",
  null
  
)

export default component.exports